import { CERTIFICATION_FRAGMENT } from 'apollo/fragments/certification-fragments';
import gql from 'graphql-tag';

export const CREATE_CERTIFICATION_MUTATION = gql`
  mutation CreateCertification($certification: CertificationCreateInput) {
    createCertification(certification: $certification) {
      ...CertificationFragment
    }
  }
  ${CERTIFICATION_FRAGMENT}
`;

export const UPDATE_CERTIFICATION_MUTATION = gql`
  mutation UpdateCertification($certification: CertificationUpdateInput) {
    updateCertification(certification: $certification) {
      ...CertificationFragment
    }
  }
  ${CERTIFICATION_FRAGMENT}
`;
